import Cookies from 'js-cookie'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray } from '@/common/js/utils'

export default {
  computed: {

  },
  data() {
    return {
      loading: null,
      pageIndex: 1,
      pageSize: parseInt(getLocal('PAGEIMAGESIZE')) || 24,
      total: 0,
      sort: '',
      order: '',
      modalColumn: false // 自定义列
    }
  },
  methods: {
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.setLocalPage(size) // 设置常用页码
      this.pageSize = size
      this.pageIndex = 1
      this.getData()
    },
    searchFilterData(params) {
      this.pageIndex = 1
      this.getData(params)
    },
    setLocalPage(size) {
      setLocal('PAGEIMAGESIZE', size)
    },
    sortTable({ prop, order }) {
      const orderType = {
        ascending: 'asc',
        descending: 'desc'
      }
      this.order = orderType[order]
      this.sort = prop
      this.pageIndex = 1
      this.getData()
    },
    filterData(params) {
      this.pageIndex = 1
      this.getData(params)
    },
    // 自定义列
    selectColumn(params) {
      this.columns = params.sort((a, b) => (a._time || 0) - (b._time || 0))
      this.modalColumn = false
    },
    getCustomStorage(name) {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal(name)
      if (storage && isArray(storage[account])) return storage[account]
      else return []
    },
    setCustomStorage(name, list) {
      const account = Cookies.get('ch_op_id')
      let storage = getLocal(name)
      if (!storage) storage = {}
      storage[account] = list
      setLocal(name, storage)
    },
    selectColumnAll(params) {
      const { type, show } = params
      const data = this.columns.filter(ret => ret.type === type)
      data.forEach(ret => {
        this.$set(ret, 'show', show)
      })
    }
  }
}
